<template>
    <div :class="cssClass"><a :href="editUrl" target="_blank" aria-label="Edit Event"><vue-feather class="title-icon" type="edit-3"></vue-feather></a></div>
</template>

<script>
import VueFeather from 'vue-feather'

export default {
    name: 'EventEditLink',

    components: {
        VueFeather,
    },

    beforeUpdate() {
        this.editUrl = process.env.VUE_APP_ADMIN_ENDPOINT + 'planner/event/event/' + this.event.id
    },

    data() {
        return {
            editUrl: '',
        }
    },

    props: {
        cssClass: {
            type: String,
            default: '',
        },
        event: {
            type: Object,
        },
    },
}
</script>

<style scoped>
a {
    color: var(--phoenix-navbar-vertical-link-color);
}
</style>